import { render, staticRenderFns } from "./contract-info-content.component.vue?vue&type=template&id=7142462d&scoped=true&"
import script from "./contract-info-content.component.vue?vue&type=script&lang=ts&"
export * from "./contract-info-content.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-info-content.component.vue?vue&type=style&index=0&id=7142462d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142462d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VSpacer,VTextField})
